module.exports = __webpack_public_path__ + "static/media/wide.e58a580b.jpg";